import swal from "sweetalert2";
import { ApiResult } from "@/services/ApiResult";
import Q from "q";

export class RequestOptions {
  public withLoader: boolean;

  constructor() {
    this.withLoader = false;
  }
}

export class RequestBuilder<T> {
  private readonly loader: boolean;
  private readonly func: () => Promise<ApiResult<T>>;

  constructor(func: () => Promise<ApiResult<T>>, opts: RequestOptions) {
    this.loader = opts.withLoader;
    this.func = func;
  }

  public build(): () => Promise<ApiResult<T>> {
    return this.loader ? this.wrappedInLoader : this.func;
  }

  private get wrappedInLoader() {
    return async () => {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading();
        },
      });
      const delay = Q.delay(400);
      const result = await this.func();
      await delay;
      swal.close();

      return result;
    };
  }
}
